import Base from "@/controllers/base";
export default class Applicant extends Base {
  constructor(elem) {
    super(elem);
  }

  driverTypeChanged(event) {
    event.target.closest("form").querySelector("input[type=submit]").disabled =
      !event.target.value;
  }

  driverTypeSwitched(event) {
    event.target.closest("form").querySelector("input[type=submit]").disabled =
      event.target.value == event.target.dataset.origin;
  }
}
